export enum Event {
  PLAYER_INTERACT = 'player-interact',
  CLOSE_UI_SCENE = 'close-ui-scene',
}
